<div class="f-as w-100p"><watercoolers-form-prompt-preview :prompt="modal.data.prompt"></watercoolers-form-prompt-preview></div>